<template>
    <div class="profile-container">
        <el-row :gutter="15">
            <el-col :xs="24" :span="12">
                <div class="input-label" >نام خانوادگی:</div>
                <el-input placeholder="نام خانوادگی" v-model="lastName"></el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">نام:</div>
                <el-input placeholder="نام" v-model="firstName"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :xs="24" :span="12">
                <div class="input-label">تلفن همراه:</div>
                <el-input placeholder="تلفن همراه" v-model="phone">
                    <template slot="append">
                        <app-cell-phone-icon/>
                    </template>
                </el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">ایمیل:</div>
                <el-input placeholder="ایمیل" v-model="email">
                    <template slot="append">
                        <app-mail-icon/>
                    </template>
                </el-input>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :xs="24" :span="12">
                <div class="input-label">جنسیت:</div>
                <el-select v-model="gender" placeholder="جنسیت" style="width:100%">
                    <el-option key="female" label="زن" value="female"></el-option>
                    <el-option key="male" label="مرد" value="male"></el-option>
                </el-select>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">نقش:</div>
                <el-select v-model="role" placeholder="نقش" style="width:100%">
                    <el-option v-for="role in roles"
                               :key="role.value"
                               :label="role.label"
                               :value="role.value">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row>
            <el-col>
                <el-button type="primary" size="medium" @click="submitUser">
                    <app-upload-icon/>
                    افزودن
                </el-button>
            </el-col>
        </el-row>

        <el-table class="startups-table" ref="multipleTable" :data="users" stripe border style="width: 100%;">
            <el-table-column class-name="table-col-rank" align="right" label="نام" :resizable="true" min-width="160">
                <template slot-scope="scope">
                    <span class="ellipsis">{{scope.row.firstName}} {{scope.row.lastName}}</span>
                </template>
            </el-table-column>

            <el-table-column class-name="table-col-name" align="right" label="ایمیل" :resizable="true" min-width="170">
                <template slot-scope="scope">
                    <span class="ellipsis">{{scope.row.email}}</span>
                </template>
            </el-table-column>

            <el-table-column class-name="table-col-categories" align="right" label="تلفن همراه" :resizable="true" min-width="90">
                <template slot-scope="scope" >
                    <span class="ellipsis">{{scope.row.phoneNumber}}</span>
                </template>
            </el-table-column>

            <el-table-column class-name="table-col-categories" align="right" label="نقش" :resizable="true" min-width="70">
                <template slot-scope="scope" >
                    <span class="ellipsis">{{scope.row.role}}</span>
                </template>
            </el-table-column>

            <el-table-column class-name="table-col-categories" align="right" label="جنسیت" :resizable="true" min-width="70">
                <template slot-scope="scope" >
                    <span class="ellipsis">{{scope.row.gender}}</span>
                </template>
            </el-table-column>

            <el-table-column class-name="table-col-desc" align="center" label="حذف" :resizable="true" :show-overflow-tooltip="true" min-width="100">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.role !== 'admin' && scope.row.role !== 'creator'"
                        type="danger"
                        size="small"
                        icon="el-icon-delete"
                        @click="deleteUser(scope.row._id)"
                        circle>
                    </el-button>
                </template>
            </el-table-column>

        </el-table>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'Users',
        data() {
            return {
                phone: '',
                email: '',
                firstName: '',
                lastName: '',
                gender: '',
                role: '',
                users: [],
                roles: [
                    {label:'مدیر', value:'admin'},
                    {label:'مشاور', value:'adviser'},
                    {label:'دبیر', value:'teacher'},
                    {label:'دانش‌ آموز', value:'student'},
                ],
            }
        },
        created() {
            this.getUsers();
        },
        methods: {
            submitUser() {
                this.$http.post(
                    `${this.apiURL}/user/new`,
                    {
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        gender: this.gender,
                        phoneNumber: this.phone,
                        role: this.role
                    }
                ).then((response) => {
                    console.log(response);
                    this.getUsers();
                }).catch((error) => {
                    console.error(error);
                });
            },
            deleteUser(userId) {
                this.$http.delete(`${this.apiURL}/user/${userId}`).then((response) => {
                    this.getUsers();
                }).catch((error) => {
                    console.error(error);
                });
            },
            getUsers() {
                this.$http.get(`${this.apiURL}/user/all`).then( (response) => {
                    this.users = response.data.users;
                }).catch( (error) => {
                    console.error(error);
                });
            },
            getRoleLabelByValue(value) {
                return this.roles.filter((v, i) => v.value === value);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .profile-container {
        width: 100%;

        .el-row {
            margin-bottom: 20px;

            .el-col {

                .ellipsis {
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-break: break-all;
                }

                .input-label {
                    font-size: 14px;
                }

                .el-input {
                    direction: ltr;

                    &::v-deep {
                        input {
                            direction: rtl;
                        }

                        .el-input-group__append {

                            svg {
                                vertical-align: text-top;
                            }
                        }
                    }
                }

                .el-button {

                    svg {
                        vertical-align: text-top;
                    }
                }
            }
        }
    }
</style>
